
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.039 1.234c-.28 0-.53.21-.53.493v4.961c0 .283.25.493.53.493h6.697c.28 0 .53-.21.53-.493v-4.96c0-.284-.25-.494-.53-.494H2.04zm8.153 1.377v-.884c0-.713-.64-1.311-1.456-1.311H2.04c-.816 0-1.456.598-1.456 1.311v4.961C.583 7.401 1.223 8 2.04 8h6.697c.816 0 1.456-.598 1.456-1.31v-.885l3.225 1.579v-6.35L10.192 2.61zm0 .936v1.322l2.299 1.125V2.42l-2.3 1.126z","fill":"#171C26"}})])
          )
        }
      }
    